import { Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { Portal } from 'components/Shared/Portal';
import { useTour } from 'newhooks/generic/useTour';

const { Tour } = lazy(
  () =>
    import(/* webpackChunkName: "tour" */ 'newcomponents/Shared/generic/Tour')
);

export const TourWrapper = () => {
  const { tourWrapperActive } = useTour();

  return tourWrapperActive ? (
    <Suspense fallback={null}>
      <Portal>
        <Tour />
      </Portal>
    </Suspense>
  ) : null;
};
